<template>
  <div style="background-color: rgb(243.9, 244.2, 244.8);position: relative;">
    <!--    标题图片-->
    <div class="first-picture-font">
      <div class="gothamBold">
        ABOUT DINGXIN
      </div>
      <div class="puHuiTi-Medium" style="font-size: 1.5rem;font-weight: lighter">
        公司简介
      </div>

      <el-image
          style="height: 2.5rem;padding-top: 0.8rem;  animation: smooth-bounce 2s infinite; /* 匀速跳动动画 */"
          :src="down" fit="cover"/>
    </div>
    <el-image
        style="width: 100%;height: 40vh"
        :src="titlePicture"
        fit="cover"
    />
    <!--走进鼎新-->
    <div>
      <el-row style="margin-top: 7.5rem">
        <el-col :offset="2" :span="8" style="text-align: left;">
          <div class="GothamBlack" style="margin-top: 1.2rem">
            <span class="profile-title company_font_blue">
            Entering
            </span>
            <br>
            <span class="profile-title">
              DingAiXin
            </span>
            <div class="puHuiTi-regular" style="font-size: 2rem;margin-top: 0.5rem">
              走进鼎新
            </div>
          </div>
          <div class="puHuiTi-regular" style="color: #4c4c4c; margin-top: 2rem;font-weight: lighter;line-height: 1.8">
            宁波鼎新是一家在齿轮行业颇具影响力的企业。公司拥有先进的生产设备和精湛的制造工艺，专注于高质量齿轮的研发、生产与销售。其产品广泛应用于机械制造、汽车工业等领域，以高精度、强耐用性获得客户的信赖。公司秉持创新理念，持续投入研发，不断优化齿轮性能，提升产品竞争力。

          </div>
          <div class="company_font_blue gothamBook" style="margin-top: 4rem">
            CONTACT US ->
          </div>
        </el-col>
        <el-col :offset="1" :span="11">
          <el-image
              style="width: 100%; height: 40vh;"
              :src="profile2"
              fit="cover"
          />
        </el-col>
      </el-row>
    </div>

    <!--走马灯-->
    <div style="margin-top: 10rem;position: relative;height: 65rem">
      <div class="image-content">
        <div>
          <div class="puHuiTi-regular" style="font-size: 2rem;font-weight: bold;">
            标准化生产车间
          </div>
          <div class="white-transparent puHuiTi-regular" style="margin-top: 1.2rem;width: 15%">
            标准化、信息化、智能化、自动化加工行业领先的智慧传动工厂
          </div>

          <div class="num-count">
    <span style="flex: 5; font-weight: lighter" class="puHuiTi-regular">
      <count-to
          v-if="isVisible"
          style="font-size: 5rem; font-weight: bold"
          :key="isVisible"
          :start-val="0"
          :end-val="60"
          :duration="3000"
      ></count-to>
      <br/>
      <span style="font-size: 1rem">进口精密设备</span>
    </span>
            <span style="flex: 1.3; font-weight: lighter" class="puHuiTi-regular">
      <count-to
          v-if="isVisible"
          style="font-size: 5rem; font-weight: bold"
          :key="`key-${isVisible}`"
          :start-val="0"
          :end-val="2"
          :duration="3000"
      ></count-to>
      <br/>
      <span style="font-size: 1rem">自动化加工及检验单元</span>


    </span>
            <span style="flex: 6; font-weight: lighter" class="puHuiTi-regular">
      <count-to
          v-if="isVisible"
          style="font-size: 5rem; font-weight: bold"
          :key="`key-${isVisible}-2`"
          :start-val="0"
          :end-val="40"
          :duration="3000"
      ></count-to>
      <br/>
      <span style="font-size: 1rem">高级模具工程师</span>


    </span>
          </div>
        </div>

      </div>

      <el-carousel height="65vh" indicator-position="none" motion-blur>
        <el-carousel-item v-for="(item,index) in images" :key="index">
          <el-image
              style="width: 100%;height: 100%"
              :src="item"
              fit="cover"
          />
        </el-carousel-item>
      </el-carousel>

      <div class="cards-container">
        <div
            class="card"
            v-for="(icon, index) in profile_icon_map"
            :key="index"
            :style="profile_icon_styles[index]"
            @mouseenter="MouseEnter(index)"
            @mouseleave="MouseLeave(index)"
        >
          <div class="number dinBold">0{{ index + 1 }}</div>
          <div v-if="index===0">
            <div class="puHuiTi-Medium card-title">标准化</div>
            <div class="puHuiTi-regular card-content">
              精准设计齿形，严选材料，
              数控加工，热处理优化，精密检测，
              为机械传动提供卓越齿轮方案。
            </div>
          </div>
          <div v-else-if="index===1">
            <div class="puHuiTi-Medium card-title">信息化</div>
            <div class="puHuiTi-regular card-content">
              集成信息系统，数据驱生产品全生命周期精准管控，提效降本。

            </div>
          </div>
          <div v-else-if="index===2">
            <div class="puHuiTi-Medium card-title">智能化</div>
            <div class="puHuiTi-regular card-content">
              智能传感、算法主导生产，故障自诊断，工艺自适应优化，效能跃升。

            </div>
          </div>
          <div v-else-if="index===3">
            <div class="puHuiTi-Medium card-title">自动化</div>
            <div class="puHuiTi-regular card-content">
              自动化产线流转，机械臂协同，少人化运作，稳定高效产出优质齿轮。
            </div>
          </div>

        </div>
      </div>

    </div>


    <!--    联系我们-->
  </div>

</template>

<script setup>
import {onMounted, onUnmounted, reactive, ref} from "vue";
import {CountTo} from 'vue3-count-to';
import down from "@/assets/img/down.png"

const titlePicture = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/profile1.png"
const profile2 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/profile2.png"
const profile3 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/profile3.png"
// const company_location = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/"assets/img/company_location.jpg')
const images = ref([profile3, profile3, profile3, profile3])
const profile_icon_map = [
  {
    blue: require('@/assets/img/icon/profile_icon1-blue.png'),
    white: require('@/assets/img/icon/profile-icon1-white.png'),
  },
  {
    blue: require('@/assets/img/icon/profile_icon1-blue.png'),
    white: require('@/assets/img/icon/profile-icon1-white.png'),
  },
  {
    blue: require('@/assets/img/icon/profile_icon1-blue.png'),
    white: require('@/assets/img/icon/profile-icon1-white.png'),
  },
  {
    blue: require('@/assets/img/icon/profile_icon1-blue.png'),
    white: require('@/assets/img/icon/profile-icon1-white.png'),
  },
];

const currentImages = ref(profile_icon_map.map((icon) => icon.blue));
const profile_icon_styles = reactive({
  0: {"background": "white", "color": "black", "left": "5%"},
  1: {"background": "white", "color": "black", "left": "30%"},
  2: {"background": "white", "color": "black", "left": "55%"},
  3: {"background": "white", "color": "black", "left": "80%"},
})
const isVisible = ref(false);


function MouseEnter(index) {
  currentImages.value[index] = profile_icon_map[index].white; // 切换为蓝色图标
  profile_icon_styles[index].background = "#2c5bb3"
  profile_icon_styles[index].color = "white"
}

function MouseLeave(index) {
  currentImages.value[index] = profile_icon_map[index].blue; // 恢复为白色图标
  profile_icon_styles[index].background = "white"
  profile_icon_styles[index].color = "black"

}

onMounted(() => {
  const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible.value = entry.isIntersecting;
      },
      {threshold: 0.5}
  );

  const target = document.querySelector('.num-count');
  if (target) observer.observe(target);

  onUnmounted(() => {
    observer.disconnect();
  });
});

</script>

<style scoped>


.card {
  width: 15rem;
  padding: 1.2rem;
  color: black;
  background-color: white; /* 设置背景颜色 */
  clip-path: polygon(0 0, 100% 0, 100% 70%, 70% 100%, 0 100%); /* 右下角剪裁 */
  text-align: left;
  font-family: Arial, sans-serif;
  position: absolute;
  top: -6rem;
  left: 2rem;
  height: 19rem;
}

.cards-container {
  display: flex;
  gap: 1.2rem;
  justify-content: space-around;
  width: 90%;
  margin-left: 5%;
  position: relative;
}

.number {
  font-size: 3rem;
  font-weight: bold;
  color: black;
}

.image-content {
  text-align: left;
  margin-left: 6.5rem;
  position: absolute;
  top: 3rem;
  z-index: 10;
  color: white;
  width: 100%;
}

.num-count {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin-top: 6.5rem
}

.card:hover > .number {
  color: white;
}

.card-content {
  color: #353535;
  margin-top: 1.2rem;
  width: 70%;
  font-size: 1rem;
  line-height: 1.5;
}

.card-title {
  text-align: left;
  font-size: 1.5rem;
  margin-top: 3rem;
}

.card:hover > div > .card-content {
  color: white;
}

</style>